/**************************************************
 * Nombre:       Formulario_Pregunta
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {SpaceBar,Numbers,Title} from "@mui/icons-material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import IngresoImagenCrop from "../../../Modulo_formularios/Componentes/IngresoImagenCrop";

const Formulario_Pregunta = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >




                <Grid container size={12} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto Icono={Title} nombre={'Pregunta'} {...props} dato={'pregunta'}/>
                </Grid>


                <Grid container size={12} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto lineas={4} nombre={'Respuesta'} {...props} dato={'respuesta'}/>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Pregunta